import { render } from "./company-edit-modal--supporter.vue?vue&type=template&id=f8ebb762&scoped=true&ts=true"
import script from "./company-edit-modal--supporter.vue?vue&type=script&lang=ts"
export * from "./company-edit-modal--supporter.vue?vue&type=script&lang=ts"

import "./company-edit-modal--supporter.vue?vue&type=style&index=0&id=f8ebb762&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ebb762"]])

export default __exports__